import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { eCriteriaVariation } from '../../services/stepper/steps/search-stepper';
import { Order, ValidationProblem } from 'reg-hub-common';
import { SteppedComponent } from 'projects/reg-hub-client/src/interfaces/stepped-component';
import { StepValidationState } from 'projects/reg-hub-client/src/interfaces/step';

@Component({
    selector: 'app-registration-number-search-review',
    templateUrl: './registration-number-search-review.component.html',
    styleUrl: './registration-number-search-review.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RegistrationNumberSearchReviewComponent extends SteppedComponent  {
  @Input() criteriaVariations: eCriteriaVariation[] = []
  protected shouldDisplaySearchFromDate: boolean = false;
  protected shouldDisplayExactSimilar: boolean = false;

  protected override init(order: Order): void {

    this.shouldDisplaySearchFromDate = this.criteriaVariations.includes(eCriteriaVariation.SearchFromDate);
    this.shouldDisplayExactSimilar = this.criteriaVariations.includes(eCriteriaVariation.ExactSimilar);

    super.init(order);
    this.validate(this.order);
  }
  
  public override getValidationState(errors: ValidationProblem[] | undefined, order: Order): StepValidationState {
    return (errors?.length ?? 0) === 0 ? StepValidationState.ValidationSuccess : StepValidationState.ValidationError;
  }
}
